import {apiFetch} from 'src/api/fetch'

import {
    type CreateSavedLocationInput,
    type SavedLocation,
    savedLocationSchema,
    toCreateSavedLocationRequest,
    toUpdateSavedLocationRequest,
    type UpdateSavedLocationInput,
} from './schemas'

export async function listCustomerSavedLocations(
    customerId: string,
    search?: string,
): Promise<SavedLocation[]> {
    const params = search ? new URLSearchParams({search}) : undefined
    const url = `/customers/${customerId}/saved-locations${params ? `?${params.toString()}` : ''}`
    const raw = await apiFetch<unknown>(url)
    return savedLocationSchema.array().parse(raw)
}

export async function createCustomerSavedLocation(
    customerId: string,
    input: CreateSavedLocationInput,
): Promise<SavedLocation> {
    const body = toCreateSavedLocationRequest(input)
    const raw = await apiFetch<unknown>(`/customers/${customerId}/saved-locations`, {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return savedLocationSchema.parse(raw)
}

export async function updateCustomerSavedLocation(
    customerId: string,
    savedLocationId: string,
    input: UpdateSavedLocationInput,
): Promise<SavedLocation> {
    const body = toUpdateSavedLocationRequest(input)
    const raw = await apiFetch<unknown>(
        `/customers/${customerId}/saved-locations/${savedLocationId}`,
        {
            method: 'PUT',
            body: JSON.stringify(body),
        },
    )
    return savedLocationSchema.parse(raw)
}

export async function deleteCustomerSavedLocation(
    customerId: string,
    savedLocationId: string,
): Promise<void> {
    await apiFetch<void>(`/customers/${customerId}/saved-locations/${savedLocationId}`, {
        method: 'DELETE',
    })
}
